import React from 'react';
import cx from 'classnames';

export enum CardsTypes {
    NONE = 'NONE',
    UPDATES = 'UPDATES',
    HELPLINE = 'HELPLINE',
    MORE_GUIDES = 'MORE_GUIDES',
}

const mapTypeToClasses = {
    [CardsTypes.NONE]: 'cards',
    [CardsTypes.UPDATES]: 'updates-cards', // @todo: merge styles
    [CardsTypes.HELPLINE]: 'cards--help-line',
    [CardsTypes.MORE_GUIDES]: 'cards--more-guides',
};

const mapTypeToTag = {
    [CardsTypes.NONE]: 'ul',
    [CardsTypes.UPDATES]: 'ul', // @todo: merge styles
    [CardsTypes.HELPLINE]: 'div',
    [CardsTypes.MORE_GUIDES]: 'ul',
};

export type CardsPropsType = {
    type?: CardsTypes;
    children?: React.ReactChild | React.ReactChild[] | Element[];
    extraClass?: string;
};

const Cards = React.forwardRef<HTMLDivElement, CardsPropsType>(
    ({ type = CardsTypes.NONE, children, extraClass }, ref) => {
        const classname = cx({
            [mapTypeToClasses[type]]: true,
            [extraClass as string]: extraClass,
        });
        const Tag = mapTypeToTag[type];

        return (
            // @ts-ignore
            // eslint-disable-next-line react/forbid-component-props
            <Tag className={classname} ref={ref} role={Tag === 'ul' ? 'list' : null}>
                {children}
            </Tag>
        );
    }
);

export default Cards;
